import { LocalStorage } from 'saddlebag-localstorage';

const LOCAL_STORAGE_NAMESPACE = 'SID';

export const DEFAULT_PERSISTENT_STATE = true;
export const PERSISTENT_KEY = 'isPersistent';

const getLocalStorage = () => new LocalStorage(LOCAL_STORAGE_NAMESPACE);

export function getSessionType() {
  const localStorage = getLocalStorage();
  const persistent = localStorage.tryGetValue(PERSISTENT_KEY, false, false);

  return persistent === null ? DEFAULT_PERSISTENT_STATE : persistent;
}

export function setSessionType(persistent: Boolean) {
  const localStorage = getLocalStorage();
  return localStorage.trySetValue(PERSISTENT_KEY, persistent, false, false);
}
